// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".otp-input {\n  width: 40px;\n  height: 40px;\n  padding: 5px;\n  margin: 0 10px;\n  font-size: 20px;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  text-align: center;\n}\n.otp-input.error {\n    border: 1px solid red !important;\n}\n.otp-input::-webkit-inner-spin-button,\n.otp-input::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
